const M = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMmMxLjE1MiAwIDIgLjg0OCAyIDJ2MTBjMCAxLjE1Mi0uODQ4IDItMiAyaC00djRjMCAxLjE1Mi0uODQ4IDItMiAySDRjLTEuMTUyIDAtMi0uODQ4LTItMlYxMGMwLTEuMTUyLjg0OC0yIDItMmg0VjRjMC0xLjE1Mi44NDgtMiAyLTJoMTB6TTggMTBINHYxMGgxMHYtNGgtNGMtMS4xNTIgMC0yLS44NDgtMi0ydi00em0xMi02SDEwdjEwaDEwVjR6IiAgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+";
export {
  M as default
};
//# sourceMappingURL=copy-03ad110c.mjs.map
